import routes from './routes';
import { SetRoutes } from 'components';

const ChainsPages = () => {
    return (
        <>
            <SetRoutes routes={routes} />
        </>
    );
};

export default ChainsPages;
